<template lang="pug">
    model-form(
        loading-text='Cargando haber o descuento...'
        ref='form'
        submit-text='guardar'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submitUpdate'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import AssetDiscountModel from '@/models/HumanResource/HrAssetDiscount'
    import AssetDiscountFields from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountFields'
    //
    export default {
        name: 'asset-discount-update',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            formProps() {
                return {
                    editable: false,
                    fields: AssetDiscountFields,
                    loading: this.busy,
                    switchEdit: true,
                    title: this.formTitle,
                }
            },

            /**
             * 
             */
            formTitle() {
                return `Haber o descuento #${this.$route.params.id}`
            },
        },
        data() {
            return {
                busy: false,
                formData: {},
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(AssetDiscountModel, error.response.data))
            },

            /**
             * 
             */
            fetch() {
                return AssetDiscountModel.modeler().find(this.$route.params.id).then(this.setFormData)
            },

            /**
             * { function_description }
             */
            redirect() {
                this.$router.push({ name: 'asset-discount-list' })
            },

            /**
             * 
             */
            reset() {
                this.setBusy(true).then(this.fetch).then(this.setBusy)
            },

            /**
             * 
             */
            async setBusy(busy = false) {
                this.busy = busy
            },

            /**
             * 
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             * 
             */
            submitUpdate() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toUpdate)
                    .catch(this.error)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            successUpdate() {
                this.setSuccessSnackbar('Haber (o descuento) actualizado exitosamente.')
            },

            /**
             *
             */
            toUpdate(model) {
                return model
                    .toUpdate()
                    .save()
                    .then(this.successUpdate)
                    .then(this.redirect)
            },
        },
        mounted() {
            this.setTitleTopBar('Detalle haber o descuento').then(this.reset)
        },
    }
</script>